import loadable from '@loadable/component';
export const Billing=loadable(() => import('./Billing'));
